<template>
  <div>
    <header-status />
    <div class="conteudo">
      <div class="licao" v-if="training">
        <div class="conversation-capa">
          <h3>Terinamento {{training.type}}</h3>
          <p>Olá, treine agora seu vocabulário e aprenda novas palavras</p>
          <img :src="training.img" alt />
        </div>

        <div class="radios">
          <p>Não sabe? clique para ouvir ao lado</p>
        </div>

        <div class="ouvirB" @click="showSom()" v-if="!ouvir">
          <a style="color:#FFF;">
            <v-icon style="color:#FFF;">fas fa-volume-up</v-icon>
            <br />Ouvir
          </a>
        </div>
        <div class="audio" v-if="ouvir">
          <audio :src="training.audio" preload="auto" controls></audio>
        </div>

        <div class="radios">
          <p>Escreva o que você vê na imagem acima ou se preferir fale para treinar a sua pronúncia</p>
        </div>

        <div class="gravarB" :class="{'blink': txt_gravar == 'Gravando'}" @click="start()">
          <v-icon
            :class="{'blink': txt_gravar == 'Gravando'}"
            style="color:#FFF"
          >fas fa-microphone-alt</v-icon>
          <br />
          <span :class="{'blink': txt_gravar == 'Gravando'}">{{txt_gravar}}</span>
        </div>
        <div class="radios">
          <v-text-field v-model="answer_digite" label="Digite a Resposta"></v-text-field>
        </div>

        <div
          class="btn-next"
          @click="verificar(training.id,answer_digite,training.answer)"
        >Responder</div>
      </div>
    </div>
    <footer-page />

    <v-dialog v-model="dialogResp" width="400px">
      <v-card>
        <v-card-title style="text-align: center;">
          <span class="headline" v-if="status == 'hit'">PARABÉNS VOCÊ ACERTOU!</span>
          <span class="headline" v-else>RESPOSTA INCORRETA!</span>
        </v-card-title>
        <v-card-text style="text-align: center;">
          <v-icon color="green" size="80" v-if="status == 'hit'">fas fa-check-circle</v-icon>
          <v-icon color="red" size="80" v-else>fas fa-times-circle</v-icon>
          <div v-if="status == 'hit' && training.translate">
            TRADUÇÃO
            <br />
            {{training.translate}}
          </div>

          <div v-if="status == 'missed'">
            <v-btn color="primary" text @click="showAnswer = true">VER RESPOSTA</v-btn>
            <br />
            <div v-if="showAnswer">{{training.answer}}</div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="dialogResp = false; showAnswer = false">REFAZER</v-btn>
          <v-btn color="primary" text @click.native="next()">PROXIMO</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-loader :active="loading"></dialog-loader>
  </div>
</template>

<script>
import { authService } from "../plugins/firebase";
export default {
  data() {
    return {
      loading: true,
      dialogResp: false,
      showAnswer: false,
      status: null,
      txt_gravar: "Gravar",
      ouvir: null,
      recognition: "",
      fala: "",
      training: null,
      answer_digite: ""
    };
  },
  created() {
    this.getTraining();
  },
  methods: {
    async getTraining() {
      this.loading = true;
      let config = {
        headers: {
          Authorization: "Bearer " + (await authService.validToken())
        }
      };
      this.$http
        .get(SERVE + "/students/training?type=Vocabulário", config)
        .then(response => {
          this.training = response.data;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          window.location.reload();
        });
    },
    showSom() {
      this.ouvir = true;
      return true;
    },
    start() {
      if (this.txt_gravar == "Gravando") return;
      this.txt_gravar = "Gravando";
      var SpeechRecognition =
        window.SpeechRecognition || window.webkitSpeechRecognition;
      this.recognition = new SpeechRecognition();
      this.fala = "";

      this.recognition.lang = "en-US";
      this.recognition.onresult = event => {
        var current = event.resultIndex;

        var transcript = event.results[current][0].transcript;

        var mobileRepeatBug =
          current == 1 && transcript == event.results[0][0].transcript;

        if (!mobileRepeatBug) {
          this.answer_digite += transcript;
          if (this.answer_digite) {
            this.txt_gravar = "Gravar";
          }
        }
      };
      this.recognition.start();
    },
    verificar(question_id, answer, check) {
      if (!answer || answer.trim() == "") return alert("Responda a Questão");
      var status = "missed";
      //answer = answer.toUpperCase();

      if (this.normalizeText(answer) == this.normalizeText(check)) {
        var status = "hit";
        //alert("Resposta Certa !!!");
      } else {
        //alert("Resposta Errada !!!");
      }

      this.status = status;
      this.dialogResp = true;
    },
    normalizeText(t) {
      t = t.normalize("NFD");
      t = t.replace(/\s\s+/g, " ");
      t = t.replace(/[0-9/,?!.:' ` ‘ ’]/g, "");
      t = t.toLowerCase();
      return t;
    },
    next() {
      this.dialogResp = false;
      this.showAnswer = false;
      this.answer_digite = "";
      this.getTraining();
    }
  }
};
</script>
<style>
</style>
